import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import enums from "./modules/enums";
import project from "./modules/project";
import synctask from "./modules/synctask";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    currentNavTitle: "",
    currentProject: null,
    isLoading: false,
  },

  mutations: {
    currentNavTitle(state, title) {
      state.currentNavTitle = title;
    },
    currentProject(state, project) {
      state.currentProject = project;
    },
    isLoading(state, value) {
      state.isLoading = value;
    },
  },

  getters: {
    appTitle() {
      return process.env.VUE_APP_APP_TITLE;
    },
  },
  actions: {},
  modules: { user, enums, project, synctask },
});

export default store;

export function useStore() {
  return store;
}
